import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { Asignacion } from '../shared/models/asignacion';
import { Solicitud } from '../shared/models/solicitud';
import { TipoAsignacion } from '../shared/models/tipo-asignacion';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { TipoAsignacionService } from '../shared/services/tipo-asignacion.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { environment } from '../../environments/environment';
import { CrearSedeDto } from '../shared/models/crear-sede-dto';
import { VlanSede } from '../shared/models/vlan-sede-dto';
import { VlanSedeService } from '../shared/services/vlanSede.service';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
import { CrearVlanParametros } from '../shared/models/crear-vlan-parametros';
import { ErrorDto } from '../shared/models/error-dto';
import { SesionService } from '../shared/services/sesion.service';
import { SuperNet } from '../shared/models/supernet';
const swal: SweetAlert = _swal as any;

@Component({
  selector: 'app-crear-supernet',
  templateUrl: './crear-supernet.component.html',
  styleUrls: ['./crear-supernet.component.css']
})
export class CrearSupernetComponent implements OnInit {


  principalForm = this.formBuilder.group({
    selectCiudad: new FormControl('', Validators.required),
    selectSede: new FormControl('', Validators.required),
    selectMascara: new FormControl('', Validators.required),
    selectAmbiente: new FormControl('', Validators.required),
    imputIpInicial: ['', Validators.required],
    imputVlan: ['', Validators.required],
    textAreaObeservaciones: new FormControl(),
  });

  codigoListaMascaras = environment.listaCodigoMascara;
  ciudades: Ciudad[];
  sedes: Sede[];
  mascaras: ListaItem[];
  ambientes: ListaItem[];
  idCiudadSeleccionada: number;
  idSedeSeleccionada: number;
  idAmbienteSeleccionado: number;
  idMascaraSeleccionada: number;
  nombreVlan: string;
  ipInicial: string;
  observaciones: string;
  parametros: SuperNet = new SuperNet();
  modalRef: NgbModalRef;
  mensajeAlerta: string;
  errorDto: ErrorDto = new ErrorDto();
  permisoCrearvlanSede: boolean;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private administradorIpService: AdministradorIpService,
    private modalService: NgbModal, private formBuilder: FormBuilder,
    private sesionService: SesionService) { }

  ngOnInit() {
    this.sesionService.permisoCrearVlanSede().subscribe(
      resultado => this.permisoCrearvlanSede = resultado
    );
    this.listarCiudades();
    this.listarMascaras();

  }



  public listarCiudades(): void {
    this.idCiudadSeleccionada = null;
    this.idSedeSeleccionada = null;
    this.ciudades = null;
    this.sedes = null;
    this.ciudadService.listarCiudades().subscribe(
      resultado => this.ciudades = resultado
    );
  }

  public listarSedesPorCiudad(): void {
    this.idSedeSeleccionada = null;
    this.sedes = null;
    this.sedeService.sedesPorCiudad(this.idCiudadSeleccionada).subscribe(
      resultado => {
        this.sedes = resultado
      });
  }

  public listarMascaras(): void {
    this.listaItemService.listarMascarasConfiguradas().subscribe(
      resultado => {
        this.mascaras = resultado
        this.idMascaraSeleccionada = resultado.find(mascara => mascara.codigoItem === '10').idListaItem

      }

    );

  }
  public listarAmbientes(): void {
    this.idAmbienteSeleccionado = null;
    this.listaItemService.ambientesPorCompaniaSedeValidaDMZ(-1,
      this.idSedeSeleccionada).subscribe( 
        resultado => this.ambientes = resultado
      );
  }

  public guardarVlanSinRango(): void {
    swal({
      title: "Procesando",
      text: "espere un momento",
      icon: "warning",
      dangerMode: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: {
      }
    } as any)
    this.parametros.idCiudad = this.idCiudadSeleccionada;
    this.parametros.idMascara = this.idMascaraSeleccionada;
    this.parametros.idSede = this.idSedeSeleccionada;
    this.parametros.idAmbiente = this.idAmbienteSeleccionado;
    this.parametros.ipInicialRango = this.ipInicial;
    this.parametros.nombreSuperNet = this.nombreVlan;
    this.parametros.observaciones = this.observaciones;
    this.parametros.indHabilitado = true;

    this.administradorIpService.crearSuperNet(this.parametros).subscribe(

      resultado => {
        this.parametros = resultado;
        swal("Se creo correctamente", "La supernet fue creada para el rango : \n" + this.parametros.ipInicialRango + " con mascara " + "255.255.0.0", "success").then(function () {
          // Redirect the user
          window.location.href = "/#/solicitar-ip";
        });
      }, error => {
        this.errorDto = error.error;
        this.mensajeAlerta = this.errorDto.mensajeError;
        swal("Se presento un error", "" + this.mensajeAlerta, "error").then(function () {
          // Redirect the user
          window.location.reload();
        })
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/crear-supernet/crear-supernet.component.ts